import React, { useState, useEffect } from 'react';
import { getPartnerLogos } from '../sanity/client';
import LogoLoop from './LogoLoop';
import './PartnersSection.css';

const PartnersSection = () => {
  const [logos, setLogos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLogos = async () => {
      try {
        const partnerLogos = await getPartnerLogos();
        // Transform Sanity data to LogoLoop format
        const formattedLogos = partnerLogos.map(partner => ({
          src: partner.logo?.asset?.url,
          alt: partner.name,
          title: partner.name,
          href: partner.url || undefined
        }));
        setLogos(formattedLogos);
      } catch (error) {
        console.error('Error fetching partner logos:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchLogos();
  }, []);

  if (loading) {
    return (
      <section className="partners-section">
        <div className="partners-container">
          <div className="partners-loading">Loading partners...</div>
        </div>
      </section>
    );
  }

  if (logos.length === 0) {
    return null; // Don't render section if no logos
  }

  return (
    <section className="partners-section">
      <div className="partners-container">
        <div className="partners-loop-wrapper">
          <LogoLoop
            logos={logos}
            speed={80}
            direction="left"
            logoHeight={60}
            gap={60}
            hoverSpeed={0}
            scaleOnHover
            fadeOut
            fadeOutColor="#1e1e1c"
            ariaLabel="Our partners"
          />
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
